export default __webpack_public_path__ + "static/media/logo-ieee.a499e542.svg";